import * as yup from 'yup';

import { addressFinderSchema } from '@components/AddressFinder/AddressFinder';

export const createFormSchema = (isSuffixRequired: boolean) =>
  yup.object({
    ...addressFinderSchema(isSuffixRequired).fields,
  });
